import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotError = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotError"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M64.71 45.06 43.44 11.11A11.09 11.09 0 0 0 34 5.88c-3.86 0-7.39 1.95-9.44 5.23L3.29 45.06a11.15 11.15 0 0 0-.31 11.31 11.15 11.15 0 0 0 9.75 5.74h42.53c4.05 0 7.78-2.2 9.75-5.74a11.15 11.15 0 0 0-.31-11.31z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M55.27 55.68H12.73c-3.7 0-5.95-4.07-3.98-7.2l21.27-33.95c1.84-2.94 6.13-2.94 7.97 0l21.27 33.95c1.96 3.13-.29 7.2-3.98 7.2z"
        clipRule="evenodd"
      />
      <path
        fill="#B7E854"
        fillRule="evenodd"
        d="M63.01 46.12 41.74 12.17A9.1 9.1 0 0 0 34 7.88c-3.16 0-6.06 1.6-7.74 4.29L4.99 46.12a9.15 9.15 0 0 0-.25 9.28 9.13 9.13 0 0 0 8 4.71h42.53c3.32 0 6.39-1.81 8-4.71a9.15 9.15 0 0 0-.25-9.28zm-7.74 9.56H12.73c-3.7 0-5.95-4.07-3.98-7.2l21.27-33.95c1.84-2.94 6.13-2.94 7.97 0l21.27 33.95c1.96 3.13-.29 7.2-3.98 7.2z"
        clipRule="evenodd"
      />
      <path
        fill="#27DBA8"
        d="m31.67 37.71-.68-10.13c-.13-1.97-.19-3.39-.19-4.25 0-1.17.31-2.08.92-2.74s1.42-.98 2.42-.98q1.815 0 2.43 1.26c.41.84.61 2.05.61 3.63 0 .93-.05 1.88-.15 2.83l-.91 10.43c-.1 1.24-.31 2.19-.63 2.86s-.86.99-1.61.99-1.29-.32-1.59-.96-.51-1.62-.63-2.93zm2.35 13.92q-1.29 0-2.25-.84t-.96-2.34c0-.87.31-1.62.92-2.23s1.36-.92 2.25-.92 1.65.31 2.27.92.94 1.36.94 2.23c0 .99-.32 1.76-.95 2.33-.63.56-1.37.85-2.22.85"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M38.41 14.26A5.18 5.18 0 0 0 34 11.82c-1.8 0-3.45.91-4.41 2.44L8.32 48.21a5.13 5.13 0 0 0-.14 5.28 5.13 5.13 0 0 0 4.55 2.68h42.53c1.92 0 3.62-1 4.55-2.68s.88-3.65-.14-5.28zm20.53 38.75a4.15 4.15 0 0 1-3.68 2.17H12.73c-1.55 0-2.93-.81-3.68-2.17s-.71-2.95.12-4.27L30.44 14.8c.77-1.23 2.1-1.97 3.56-1.97s2.79.74 3.56 1.97l21.27 33.95c.82 1.31.87 2.91.12 4.27z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M63.44 45.86 42.17 11.91A9.59 9.59 0 0 0 34 7.39c-3.34 0-6.39 1.69-8.17 4.52L4.56 45.86a9.645 9.645 0 0 0 8.17 14.76h42.53c3.5 0 6.74-1.9 8.43-4.97 1.7-3.07 1.6-6.82-.26-9.79zm-.61 9.3a8.65 8.65 0 0 1-7.56 4.46H12.73c-3.14 0-6.04-1.71-7.56-4.46a8.64 8.64 0 0 1 .24-8.77l21.27-33.95A8.59 8.59 0 0 1 34 8.39c2.99 0 5.73 1.51 7.32 4.05l21.27 33.95a8.64 8.64 0 0 1 .24 8.77"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M34.15 19.11c-1.14 0-2.08.38-2.79 1.14-.7.75-1.06 1.78-1.06 3.08 0 .87.06 2.31.19 4.28l.68 10.13c.13 1.4.36 2.41.68 3.11.38.82 1.08 1.25 2.04 1.25s1.65-.44 2.06-1.27c.35-.73.58-1.72.68-3.03l.91-10.42c.1-.97.15-1.94.15-2.88 0-1.67-.22-2.93-.66-3.85-.5-1.02-1.47-1.54-2.88-1.54m2.4 8.17-.91 10.43c-.09 1.17-.29 2.07-.59 2.68-.24.49-.6.71-1.16.71s-.92-.21-1.13-.67c-.27-.59-.47-1.51-.59-2.76l-.68-10.12c-.13-1.95-.19-3.37-.19-4.22 0-1.03.26-1.84.79-2.4.52-.56 1.19-.83 2.06-.83 1.01 0 1.66.32 1.98.98.37.77.56 1.91.56 3.41 0 .91-.05 1.85-.15 2.79zM33.98 44.8c-1.02 0-1.9.36-2.61 1.07s-1.07 1.58-1.07 2.58c0 1.15.38 2.06 1.13 2.71.73.64 1.6.96 2.58.96s1.83-.33 2.55-.97c.74-.66 1.12-1.57 1.12-2.7 0-1.01-.37-1.88-1.09-2.59s-1.6-1.06-2.62-1.06zm1.93 5.61c-.54.48-1.16.72-1.89.72s-1.37-.23-1.93-.71c-.53-.46-.79-1.1-.79-1.96 0-.74.25-1.36.77-1.88s1.14-.77 1.9-.77 1.39.25 1.92.78c.53.52.79 1.13.79 1.87 0 .85-.26 1.48-.78 1.95z"
      />
    </svg>
  );
};
export default IllustrationSpotError;
